<template>
    <LsDropdown v-model="localValue" :options="options" :track-id="trackId" />
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import LsDropdown from './LsDropdown.vue';
import LsProperty from './components/LsProperty.vue';
import LsNewProperty from './components/LsNewProperty.vue';

export default {
    name: 'LsDropdownProperties',
    components: { LsDropdown },
    props: {
        canAdd: VueTypes.bool,
        value: VueTypes.any.isRequired,
        properties: VueTypes.arrayOf(
            VueTypes.shape({
                id: VueTypes.string.isRequired,
                street: VueTypes.string.isRequired,
                state: VueTypes.string.isRequired,
                city: VueTypes.string.isRequired,
                zip: VueTypes.string.isRequired,
            }).isRequired.loose
        ).isRequired,
        trackId: VueTypes.string.isRequired,
    },
    defaultProps: {
        canAdd: true,
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        options() {
            let properties = _.map(this.properties, (property) => {
                return {
                    value: property.id,
                    label: property.street,
                    component: LsProperty,
                    props: {
                        property,
                    },
                };
            });

            if (this.canAdd) {
                properties = _.concat(properties, [
                    {
                        value: '0',
                        component: LsNewProperty,
                    },
                ]);
            }

            return properties;
        },
    },
};
</script>
